import { useTranslations } from "next-intl";
import { Button } from "@components/core";
import useFeatures from "@hooks/use-features";

function BrandTagButtons({ tag, setTag }) {
  const t = useTranslations("brands");

  const features = useFeatures();
  const brandTags = features?.brand_tags || [];

  if (!brandTags || brandTags.length === 0) return null;

  return (
    <div className="brand-tags-wrapper">
      <div className="brand-tags brands-wrapper-padding-x">
        <Button
          variant={!tag ? "middle-primary" : "outline-primary"}
          size="sm"
          pill
          hugContent
          onClick={() => setTag(null)}
        >
          {t("brand_glossary.all_brands")}
        </Button>
        {brandTags.map((brandTag, index) => (
          <Button
            key={`${brandTag}-${index}`}
            variant={brandTag === tag ? "middle-primary" : "outline-primary"}
            size="sm"
            pill
            hugContent
            onClick={() => setTag(brandTag)}
          >
            {t(`brand_glossary.brand_tag.${brandTag}`)}
          </Button>
        ))}
      </div>
    </div>
  );
}

export default BrandTagButtons;
